import { Card, Flex } from "antd";

const ActualOnAcceptanceSection = () => {
  return (
    <Card>
      <Flex vertical gap={10}>
        <Flex style={{ color: "#aeaeae" }} align="center" gap={5}>
          <div style={{ marginTop: 2 }}>Трудозатраты</div>
        </Flex>

        <div>
          Обязательно заполнение фактических трудозатрат перед переводом задачи
          в статус "Приемка".
        </div>
      </Flex>
    </Card>
  );
};

export default ActualOnAcceptanceSection;
